import { commWebApi } from '@/api/index';
import { Api, Spectra, SpectraModule } from '@/decorators';

@Spectra({ namespaced: true, name: 'Evaluation' })
export default class extends SpectraModule {
  @Api({ CORS: true }) evaluationHome = commWebApi.postCommWebApiEvaluationHome;
  @Api({ CORS: true }) evaluationPage = commWebApi.postCommWebApiEvaluationPage;
  @Api({ CORS: true }) evaluationDetail = commWebApi.postCommWebApiEvaluationDetail;
  @Api({ CORS: true }) personList = commWebApi.postCommWebApiPersonList;
  @Api({ CORS: true }) postCommWebApiPersonDetail = commWebApi.postCommWebApiPersonDetail;
  @Api({ CORS: true }) organizationList = commWebApi.postCommWebApiOrganizationList;
  @Api({ CORS: true }) commWebApiUserMe = commWebApi.postCommWebApiUserMe;
  @Api({ CORS: true }) commWebApiUserUpdate = commWebApi.postCommWebApiUserUpdate;
}
